export interface FormValues {
  name: string;
  searchTerm: string;
  supplier: string;

  amountFrom: number | "";
  amountTo: number | "";
  outStandingBalanceFrom: number | "";
  outStandingBalanceTo: number | "";

  dateFrom: string;
  dateTo: string;

  dueDateFrom: string;
  dueDateTo: string;

  uploadDateFrom: string;
  uploadDateTo: string;

  exportDateFrom: string;
  exportDateTo: string;

  docRef: string;
  itemId: string;
  type: string;
  currencyCode: string;
  payment: string;

  user: string;
  submittedBy: string;
  submittedByLabel: string;
  submissionMethod: string;
  category: string;
  expenseClaim: string;
}

export const toInvoiceSearchPayload = (activeSearch: Partial<FormValues> | null) => {
  if (!activeSearch) return null;

  const { submittedByLabel: _submittedByLabel, ...searchFields } = activeSearch;
  const filled = Object.fromEntries(
    Object.entries(searchFields).filter(([, value]) => value !== "" && value !== null)
  );

  return Object.keys(filled).length ? filled : null;
};